import {
  fontCSS,
  filledOutlineShadow,
  defaultState,
  focusedState,
  errorState,
  disabledState,
  readOnlyState
} from 'components/v2/common.styled';
import { Status } from 'components/v2/types';
import styled, { css } from 'styled-components';

export const textareaBaseCSS = css`
  ${fontCSS}
  line-height: 24px;
  padding: 20px 24px;
  border: 0;
  color: ${defaultState.textColor};
  width: 100%;
  border-radius: ${defaultState.borderRadius};
  background-color: ${defaultState.backgroundColor};
  border-style: ${defaultState.borderStyle};
  border-color: ${defaultState.borderColor};
  border-width: ${defaultState.borderWidth};
  box-shadow: ${defaultState.boxShadow};

  /* Multiline-friendly defaults */
  white-space: pre-wrap;
  overflow: auto;
  text-overflow: initial;
  display: block;
  resize: vertical;

  ::placeholder {
    color: ${defaultState.placeholderColor};
  }
`;

export const textareaStatusStyle: Record<Status, ReturnType<typeof css>> = {
  default: css`
    -webkit-appearance: none;
    &:focus {
      box-shadow: ${focusedState.boxShadow};
      -webkit-appearance: none;
    }
  `,
  error: css`
    color: ${errorState.textColor};
    box-shadow: ${errorState.boxShadow};

    ::placeholder {
      color: ${errorState.placeholderColor};
    }
  `,
  disabled: css`
    color: ${disabledState.textColor};
    background: ${disabledState.backgroundColor};
    cursor: ${disabledState.cursor};

    ::placeholder {
      color: ${disabledState.placeholderColor};
    }
  `,
  readOnly: css`
    color: ${readOnlyState.textColor};
    background: ${readOnlyState.backgroundColor};
    border-width: ${readOnlyState.borderWidth};
    border-style: ${readOnlyState.borderStyle};
    border-color: ${readOnlyState.borderColor};
    cursor: ${readOnlyState.cursor};

    ::placeholder {
      color: ${disabledState.placeholderColor};
    }
  `
};

export const TextAreaStyled = styled.textarea<{
  status: Status;
  $isFilled: boolean;
  backgroundColor?: string;
  height?: string;
}>`
  ${textareaBaseCSS}
  ${({ $isFilled }) =>
    $isFilled &&
    css`
      box-shadow: ${filledOutlineShadow};
    `}
  ${({ status }) => textareaStatusStyle[status]}
  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background: ${backgroundColor};
    `}

  height: ${({ height }) => height || '120px'};
`;

export const Container = styled.div<{ fullWidth?: boolean }>`
  position: relative;
  display: flex;
  justify-items: flex-start;
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      flex: 1;
    `}
`;
